module.exports = __webpack_public_path__ + "static/img/img_4.5fe294da.jpg";